(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const selector = '.main-product__blocks shopify-payment-terms';
    const highlightClass = 'pmp-installment-amount';
    const styleAttribute = 'data-pmp-installment-highlight';

    const getInstallmentAmount = (paymentTerms) => {
      try {
        const meta = JSON.parse(paymentTerms.getAttribute('shopify-meta') || '{}');

        if (Array.isArray(meta.variants)) {
          const variantId = paymentTerms.getAttribute('variant-id');
          const variant = meta.variants.find((item) => String(item.id) === String(variantId));
          return variant?.price_per_term || '';
        }

        return meta.price_per_term || '';
      } catch {
        return '';
      }
    };

    const applyHighlight = (paymentTerms) => {
      const root = paymentTerms.shadowRoot;
      const amount = getInstallmentAmount(paymentTerms);

      if (!root || !amount) return;

      if (!root.querySelector(`style[${styleAttribute}]`)) {
        const style = document.createElement('style');
        style.setAttribute(styleAttribute, '');
        style.textContent = `
          .${highlightClass} {
            display: inline-block;
            margin-inline: 0.06em;
            padding: 0.03em 0.24em 0.06em;
            border-radius: 0.3em;
            background: rgba(34, 189, 232, 0.09);
            color: #dff8ff;
            box-shadow: inset 0 0 0 1px rgba(34, 189, 232, 0.14);
            font-weight: 650;
          }
        `;
        root.appendChild(style);
      }

      const content = root.querySelector('#shopify-installments-content');
      if (!content) return;

      const currentHighlight = content.querySelector(`.${highlightClass}`);
      if (currentHighlight?.textContent === amount) return;

      if (currentHighlight) {
        currentHighlight.replaceWith(document.createTextNode(currentHighlight.textContent || ''));
      }

      const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();

      while (textNode) {
        const value = textNode.nodeValue || '';
        const amountIndex = value.indexOf(amount);

        if (amountIndex !== -1) {
          const fragment = document.createDocumentFragment();
          const highlight = document.createElement('span');
          highlight.className = highlightClass;
          highlight.textContent = amount;

          fragment.append(value.slice(0, amountIndex), highlight, value.slice(amountIndex + amount.length));
          textNode.replaceWith(fragment);
          return;
        }

        textNode = walker.nextNode();
      }
    };

    const observePaymentTerms = (paymentTerms) => {
      if (paymentTerms.pmpInstallmentHighlightBound) return;
      paymentTerms.pmpInstallmentHighlightBound = true;

      let attempts = 0;
      let updateScheduled = false;

      const connect = () => {
        const root = paymentTerms.shadowRoot;

        if (!root) {
          attempts += 1;
          if (attempts < 120) requestAnimationFrame(connect);
          return;
        }

        const scheduleUpdate = () => {
          if (updateScheduled) return;
          updateScheduled = true;
          requestAnimationFrame(() => {
            updateScheduled = false;
            applyHighlight(paymentTerms);
          });
        };

        new MutationObserver(scheduleUpdate).observe(root, {
          childList: true,
          characterData: true,
          subtree: true,
        });

        new MutationObserver(scheduleUpdate).observe(paymentTerms, {
          attributes: true,
          attributeFilter: ['variant-id', 'shopify-meta'],
        });

        scheduleUpdate();
      };

      customElements.whenDefined('shopify-payment-terms').then(connect);
    };

    const initialize = (scope = document) => {
      const paymentTerms = [
        ...(scope.matches?.(selector) ? [scope] : []),
        ...scope.querySelectorAll(selector),
      ];

      paymentTerms.forEach(observePaymentTerms);
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
